const projects = [
  {
    title: "Pingüi: Learn Through Stories",
    desc: "Aplicación móvil para el aprendizaje de palabras mediante historias multilingüe.",
    tech: ["Expo", "Render", "TypeScript", "Supabase", "DeepSeek", "API REST"],
    deploy: "https://play.google.com/store/apps/details?id=com.pingui.learningwords",
    image: `${process.env.PUBLIC_URL}/img/Pingui.JPG`,
  },
  {
    title: "DevAPIStore",
    desc: "Sistema de gestión de ventas de todo tipo de categoría.",
    tech: ["Next.js", "HTML", "JavaScript", "Tailwind CSS", "MongoDB Cloud Atlas", "API REST"],
    github: "https://github.com/kirth8/DevAPIStore",
    deploy: "https://kirth8.shop",
    image: `${process.env.PUBLIC_URL}/img/DevAPIStore.JPG`,
  },
  {
    title: "Portfolio Website",
    desc: "Proyecto visual para poder presentar mi persona a entidades de interés.",
    tech: ["React", "HTML", "CSS Modules", "JavaScript"],
    github: "https://github.com/kirth8/helloportafolio",
    deploy: "https://kirth8.site",
    image: `${process.env.PUBLIC_URL}/img/Portafolio.JPG`,
  },
  {
    title: "Manjilu",
    desc: "Proyecto de accesibilidad para poder traducir el lenguaje de señas con salida de texto.",
    tech: ["Flask", "HTML", "Python", "CSS", "JavaScript", "CNN"],
    github: "https://github.com/kirth8/Manjilu",
    image: `${process.env.PUBLIC_URL}/img/Manjilu.JPG`,
  },
  {
    title: "Menú indicativo de ubicación interactivo",
    desc: "Guía visual con recorridos 360° para las personas visitantes para poder ver el campus de la UNL.",
    tech: ["React", "JavaScript", "CSS", "DBFirebase", "API REST"],
    github: "https://github.com/kirth8/MenuServiciosComunitarios1",
    image: `${process.env.PUBLIC_URL}/img/MenuInteractivo.JPG`,
  },
  {
    title: "InstantSale",
    desc: "Proyecto personal para poder usar la base de datos para poder vender y comprar productos por subasta.",
    tech: ["DJango", "HTML", "Python", "CSS", "JavaScript", "DBSQlite", "API REST", "Docker"],
    github: "https://github.com/kirth8/InstantSate_Docker",
    image: `${process.env.PUBLIC_URL}/img/InstantSale.JPG`,
  },
  {
    title: "Menú de Trabajos",
    desc: "Menú hecho en la universidad, donde compone algunos trabajos sueltos hechos con funcionalidad individual.",
    tech: ["HTML", "JavaScript", "Css", "PHP"],
    github: "https://github.com/kirth8/KeynerManchayEjemplo1",
    image: `${process.env.PUBLIC_URL}/img/MenuTrabajos.JPG`,
  },

];

export default projects;